import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !ANON_KEY) {
  console.warn("[shukan] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing");
}

// Fallback to placeholder values to prevent throwing "supabaseUrl is required" on load.
// This allows the app to load and display warning/error states in the UI.
const safeUrl = SUPABASE_URL || "https://placeholder-please-set-env.supabase.co";
const safeKey = ANON_KEY || "placeholder-anon-key";

export const supabase = createClient(safeUrl, safeKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});

export async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
